export function shouldOpenWhatsAppDirectly() {
  if (typeof window === "undefined") return false;

  const ua = window.navigator.userAgent || "";
  const isMobileOrTabletUA = /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(ua);
  const hasTouch = window.navigator.maxTouchPoints > 0;
  const isTabletOrSmallerViewport = window.matchMedia("(max-width: 1280px)").matches;

  return isMobileOrTabletUA || (hasTouch && isTabletOrSmallerViewport);
}
